import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeUrl } from "@uplift-ltd/strings";
import React, { useCallback } from "react";
import Button from "components/common/Button";
import CreditHoursBadge from "components/common/CreditHoursBadge/CreditHoursBadge";
import Link from "components/common/Link";
import { BUNDLE_URL, SUBSCRIPTIONS_URL } from "constants/urls";
import { formatUSD } from "helpers/strings";
import { useAnchorRef } from "hooks/useAnchorRef";
import useRouterNavigation from "hooks/useRouterNavigation";
import { CourseCatalogGroupsQueryCourses as GroupedCourse } from "./__generated__/CourseCatalog";
import styles from "./Course.module.css";

interface CourseGroupProps {
  title: string | null;
  slug: string | null;
  priceUSD: number;
  ceUnits: number;
  isEnrolled: boolean;
  courses: GroupedCourse[];
  isMembersExclusive: boolean;
}

const CourseGroup: React.FC<CourseGroupProps> = ({
  title,
  slug: courseGroupSlug,
  priceUSD,
  ceUnits,
  isEnrolled,
  courses,
  isMembersExclusive,
}) => {
  // satisfy ts
  const slug = courseGroupSlug || "";

  const ref = useAnchorRef<HTMLDivElement>(slug);
  const { push } = useRouterNavigation();
  const onClickTakeCourse = useCallback(() => {
    push(makeUrl(BUNDLE_URL, { slug }));
  }, [push, slug]);

  return (
    <div className={styles.course} id={slug || undefined} ref={ref}>
      <div className={styles.courseDetails}>
        <Link
          as={makeUrl(BUNDLE_URL, { slug })}
          href="/packages/[slug]"
          className={styles.courseTitleLink}
        >
          <h3 className={styles.courseTitle}>{title}</h3>
        </Link>
        Courses:
        <ul className={styles.groupedCourses}>
          {courses.map(course => (
            <li key={course.id}>{course.title}</li>
          ))}
        </ul>
      </div>
      <div className={styles.coursePurchase}>
        <div>
          <CreditHoursBadge ceUnits={ceUnits} />
        </div>
        <div className={styles.coursePriceAndButtonContainer}>
          <div className={styles.coursePrice}>{formatUSD(priceUSD)}</div>
          {isMembersExclusive && (
            <div className={styles.membersOnly}>
              <Link href={makeUrl(SUBSCRIPTIONS_URL, { slug: "" })}>Members Only</Link>
            </div>
          )}
          <div className={styles.courseButtonContainer}>
            <Button
              theme={isEnrolled ? "primary" : "light"}
              className={styles.courseButton}
              onClick={onClickTakeCourse}
              icon={isEnrolled && <FontAwesomeIcon icon={faCheck} className="mr-1" />}
            >
              {isEnrolled ? "Enrolled" : "Learn More"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseGroup;
